import React from "react";
import { Turnstile } from "@marsidev/react-turnstile";

export const TS_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

export default function TurnstileField({ onToken }) {
  if (!TS_KEY) return null;
  return (
    <div className="flex justify-center" data-testid="turnstile-widget">
      <Turnstile siteKey={TS_KEY} onSuccess={onToken} onExpire={() => onToken(null)} onError={() => onToken(null)}
        options={{ appearance: "interaction-only", theme: "light", size: "flexible" }} />
    </div>
  );
}
